module.exports = "/images/is.svg?79d0a3979c4e78f37a9319a0597176da";